var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.363 14.732C15.363 15.575 14.6781 16.2606 13.8361 16.2606H9.27759C8.4355 16.2606 7.75061 15.575 7.75061 14.732V10.1686C7.75061 9.32559 8.4355 8.63995 9.27759 8.63995H10.6024V7.11133H9.27759C7.59342 7.11133 6.22363 8.4826 6.22363 10.1686V14.7207C6.22363 16.4067 7.59342 17.778 9.27759 17.778H13.8248C15.509 17.778 16.8788 16.4067 16.8788 14.7207V13.4057H15.363L15.363 14.732Z",
    fill: "#525D71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1268 7.11133H12.2981V8.63995H14.2854L10.0638 12.8662C9.76063 13.1584 9.76063 13.6529 10.0638 13.9452C10.2098 14.0914 10.4118 14.17 10.6027 14.17C10.7936 14.17 10.9957 14.0913 11.1416 13.9452L15.3633 9.71903V11.7085H16.8902L16.8903 7.8757C16.8903 7.44865 16.5535 7.11143 16.1269 7.11143L16.1268 7.11133Z",
    fill: "#525D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website-icon.1d434e7be1d952213733c352680a3a58.svg";
export { ForwardRef as ReactComponent };